<template>
  <div class="mb-3">
    <div class="container">
      <div class="row">
        <div class="col">
          <span
            v-if="state.stateLabel"
            class="badge badge-pill"
            :class="`badge-${state.color}`"
          >
            {{ label }}
          </span>
          <span v-if="state.version" class="badge badge-secondary">
            Version: {{ state.version }}
          </span>
        </div>
        <div v-if="state.state === 'executed'" class="col text-right">
          <DownloadPDF @error="(err) => errors = err" @triggered="triggered = true" :asset="asset" />
          <div v-if="triggered || errors.length > 0">
            <small v-if="triggered" class="text-success">You'll be sent an email when the PDF is ready to download.</small>
            <small v-if="errors.length > 0" class="text-danger">{{ this.errors[0] }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadPDF from '@/Shared/DownloadPDF';
import helpers from '@/Mixins/helpers';

export default {
  mixins: [helpers],

  components: {
    DownloadPDF,
  },

  props: {
    asset: Object,
    state: Object,
    organisationId: String,
  },

  data() {
    return {
      triggered: false,
      downloading: false,
      errors: [],
    };
  },

  computed: {
    originator() {
      return this.$page.props.auth.user.organisation.id === this.organisationId;
    },

    label() {
      if (this.userHasType('clausify')) {
        if (this.originator) {
          if (!this.state.withCounterparty) return this.state.stateLabel.organisation;
          if (this.state.withCounterparty) return this.state.stateLabel.counterparty;
        }

        if (!this.originator) {
          if (this.state.withCounterparty) return this.state.stateLabel.organisation;
          if (!this.state.withCounterparty) return this.state.stateLabel.counterparty;
        }
      }

      if (this.state.withCounterparty) return this.state.stateLabel.organisation;
      if (!this.state.withCounterparty) return this.state.stateLabel.counterparty;

      return this.asset.state_label.organisation;
    },
  },
};
</script>
